"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const JsonLdHelper_1 = require("./JsonLdHelper");
/**
 * Provides a logic checking type of RDF resources.
 */
class IndirectTypingProvider {
    /**
     * Initializes a new instance of the {@link IndirectTypingProvider} class.
     * @param {IOntologyProvider} ontologyProvider Provider of predicate range-domain details.
     */
    constructor(ontologyProvider) {
        this.ontologyProvider = ontologyProvider;
    }
    /**
     * Checks whether a currently processed resource within a given processing state is of a given type.
     * @param expectedType {string} Type to check against.
     * @param {ProcessingState} processingState Current JSON-LD processing state.
     * @returns {Promise<boolean>}
     */
    async isOfType(expectedType, processingState) {
        return (this.isOfClass(expectedType, processingState) ||
            (await this.isInDomainOfPredicate(expectedType, processingState)) ||
            (await this.isInRangeOfPredicate(expectedType, processingState)));
    }
    isOfClass(expectedType, processingState) {
        return (processingState.processedObject["@type"] instanceof Array &&
            processingState.processedObject["@type"].indexOf(expectedType) !== -1);
    }
    async isInDomainOfPredicate(expectedType, processingState) {
        for (const property of JsonLdHelper_1.JsonLdHelper.validKeys(processingState.processedObject)) {
            const domain = await this.ontologyProvider.getDomainFor(property);
            if (domain === expectedType) {
                return true;
            }
        }
        return false;
    }
    async isInRangeOfPredicate(expectedType, processingState) {
        const ownerResource = processingState.findRawResource(processingState.parentIri);
        if (!ownerResource) {
            return false;
        }
        for (const property of JsonLdHelper_1.JsonLdHelper.validKeys(ownerResource)) {
            const range = await this.ontologyProvider.getRangeFor(property);
            if (range === expectedType &&
                ownerResource[property].find(_ => _["@id"] === processingState.processedObject["@id"])) {
                return true;
            }
        }
        return false;
    }
}
exports.default = IndirectTypingProvider;
//# sourceMappingURL=IndirectTypingProvider.js.map